import Warning from './Warning.vue';

export default Warning;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/warning/index.ts